import type { EvidenceItem } from "@/mocks/gossip";

const levelTone = (level: string) => {
  if (level.includes("直接")) return "bg-primary-500 text-background-50";
  if (level.includes("不可采信")) return "bg-secondary-300 text-secondary-950";
  if (level.includes("待核实")) return "bg-background-300 text-foreground-800";
  if (level.includes("弱相关")) return "bg-background-200 text-foreground-600";
  return "bg-accent-500 text-accent-950";
};

export default function EvidenceList({ items }: { items: EvidenceItem[] }) {
  return (
    <div className="flex flex-col gap-3">
      {items.map((it, idx) => (
        <article
          key={`${it.label}-${idx}`}
          className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
        >
          <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-lg bg-background-200 text-foreground-700">
            <i className="ri-attachment-2 text-lg"></i>
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2.5">
              <h3 className="font-heading font-semibold text-[15px] md:text-base text-foreground-950">
                {it.label}
              </h3>
              <span className="rounded-full bg-background-200 px-2.5 py-0.5 font-label text-[11px] text-foreground-600">
                {it.type}
              </span>
              <span className={`rounded-full px-2.5 py-0.5 font-label text-[11px] ${levelTone(it.level)}`}>
                可信度：{it.level}
              </span>
            </div>
            <p className="mt-1.5 font-label text-sm leading-relaxed text-foreground-600">{it.desc}</p>
          </div>
        </article>
      ))}
    </div>
  );
}